export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
export const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-NHHL7K';
export const OAUTH_URL = process.env.REACT_APP_OAUTH_URL;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || '/';
export const TRANSLATIONS_PATH = `${
  process.env.REACT_APP_COMMIT_SHA ? `i18n/${process.env.REACT_APP_COMMIT_SHA.substring(0, 7)}` : 'static/i18n'
}/`;
export const HAPI_URL = 'https://generic.wg.spotify.com/hapi/v1';
export const SUSI_URL = process.env.REACT_APP_SUSI_URL || '';
export const SP_API_URL = 'https://api.spotify.com';
export const SP_ACCOUNTS_URL = 'https://accounts.spotify.com';
export const MASTHEAD_URL = process.env.REACT_APP_MASTHEAD_URL || 'https://www.spotify.com/api/masthead/v1/masthead';
export const SP_EMBED_URL = 'https://embed.spotify.com';
export const SUPPORT_SITE_URL = process.env.REACT_APP_SUPPORT_SITE_URL || 'https://support.spotify.com';
export const SPOTIFYCOM_URL = 'https://www.spotify.com';
export const CONTENTREPORTINGAPI_URL = process.env.REACT_APP_CONTENTREPORTING_API_URL || '';
